import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    imageSrcDataURL:'',
    previewImageSrcDataURL: '',
    maskImage: '',
    firstName: '',
    lastName: '',
    yourFirstName: '',
    yourLastName: '',
    noteType: 0,
    selectedMessage: ''
  },
  mutations: {
    setSrcImage(state, dataURL) {
      state.imageSrcDataURL = dataURL
    },
    setPreviewImage(state, dataURL) {
      state.previewImageSrcDataURL = dataURL
    },
    setMaskImage(state, maskImage) {
      state.maskImage = maskImage
    },
    setFirstName(state, firstName) {
      state.firstName = firstName
    },
    setLastName(state, lastName) {
      state.lastName = lastName
    },
    setNoteType(state, noteType) {
      state.noteType = noteType
    },
    setSelectedMessage(state, selectedMessage) {
      state.selectedMessage = selectedMessage
    },
    setYourFirstName(state, yourFirstName) {
      state.yourFirstName = yourFirstName
    },
    setYourLastName(state, yourLastName) {
      state.yourLastName = yourLastName
    },
    setEmail(state, email) {
      state.email = email
    },
  },
  actions: {

  }
})
